<template>
  <div>

    <div style="text-align:right; margin-top:20px;margin-bottom:20px; margin-right:15%">
      <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="taxFormAdd">新規</el-button>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%;" :empty-text="$t('general.empty_data')">
      <el-table-column prop="employee_id" label="従業員番号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="従業員氏名" align="center">
        <template slot-scope="scope">
            <el-button type="text">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>

      <el-table-column prop="year" label="年度" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.year }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="preparation_tax_amount" label="源泉徴収税額" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.preparation_tax_amount }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="440px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{ $t("general.edit") }}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeleteAll(scope.$index, scope.row)">
            {{ $t("general.delete") }}</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="handleFamily(scope.$index, scope.row)">
            {{ $t("empList.family_info") }}</el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printTaxForm(scope.$index, scope.row)">源泉徴収票</el-button>
        </template>
      </el-table-column>
    </el-table>

<!-- 源泉徴収票新規作成 -->
    <el-dialog title="給与所得の源泉徴収票" :visible.sync="dialogAdd" width="72%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <el-row style=" text-align:left;　margin-bottom:40px;">
            <el-col :span="4">
              <el-button type="primary" size="mini" @click="dialogIns = true">給与所得者の保険料控除申告書</el-button>
            </el-col>
          </el-row>
          <el-row style=" text-align:left; font-weight:bold;">
            <el-col :span="4">
              <el-form-item prop="year">年度
                <el-select style="width:120px;margin-left:10px;" v-model="ruleForm.year" size="mini" :placeholder="$t('general.select')">
                  <el-option v-for="item in year" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        　<el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="受給者基本情報" name="1">
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                 
                  <el-form-item label="受給者番号" prop="employee_id">
                    <el-select v-model="ruleForm.employee_id" style="width: 180px;" size="mini" @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                                  
                  <el-form-item label="個人番号" prop="mynum">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                 
                  <el-form-item label="氏名" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini" style="width: 180px; margin-left:40px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                 
                  <el-form-item label="氏名(フリガナ）" prop="name_frgn">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name_frgn" size="mini" style="width: 180px; margin-right:45px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>               
             </el-row>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                                  
                  <el-form-item label="生年月日" prop="birthday">
                    <el-date-picker v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd" style="width: 180px; margin-left:10px; " type="date" readonly="readonly"></el-date-picker>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                                  
                  <el-form-item label="役職名" prop="title">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.title" size="mini" style="width: 180px; margin-left:15px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>               
             </el-row>  
            　<el-row>
              　<el-col :span="24">
                <div style="margin-left:50px;">                 
                  <el-form-item label="住所または居所" prop="address">
                    <el-input prefix-icon="el-icon-info" :value="'〒'+ruleForm.post_code+'  '+ruleForm.address1+ruleForm.address2+ruleForm.address3" size="mini" style="width: 700px; margin-right:35px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
             </el-row>             
          　</el-collapse-item>

          　<el-collapse-item title="受給者" name="2">
            　<el-row style="text-align:left;">
              　<el-col :span="4" style="margin-left:50px;">          
                  <el-form-item label="本人が障害者" prop="recevier_type_disabled">
                    <el-select style="width:80%;" v-model="ruleForm.recevier_type_disabled" size="mini" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in disabled" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>
              　<el-col :span="4" style="margin-left:74px;">                
                  <el-form-item label="寡婦/ひとり親の控除対象" prop="recevier_type_single">
                    <el-select style="width:90%;" v-model="ruleForm.recevier_type_single" size="mini" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in single" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>
              　<el-col :span="4" style="margin-left:74px;">                
                  <el-form-item label="中途就・退職" prop="mid_career">
                    <el-select style="width:80%;" v-model="ruleForm.mid_career" size="mini" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in mid_career" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>
              　<el-col :span="4"  style="margin-left:74px;">
                <div v-if="ruleForm.mid_career!=''">                 
                  <el-form-item label="年月日" prop="career_date">
                    <el-date-picker v-model="ruleForm.career_date" size="mini" value-format="yyyy-MM-dd" style="width: 80%" type="date"></el-date-picker>
                  </el-form-item>
                </div>
               </el-col>                                             
             </el-row>                         
            　<el-row>
              　<el-col :span="24">
                <div style="margin-left:50px; text-align:left;">                                  
                  <el-form-item>
                    <el-checkbox v-model="ruleForm.recevier_is_work_student">勤労学生</el-checkbox>
                    <el-checkbox v-model="ruleForm.recevier_is_Foreign">外国人</el-checkbox>
                    <el-checkbox v-model="ruleForm.recevier_is_death">死亡退職</el-checkbox>
                    <el-checkbox v-model="ruleForm.recevier_is_saigai">災害者</el-checkbox>
                    <el-checkbox v-model="ruleForm.recevier_is_b">乙欄</el-checkbox>
                  </el-form-item>
                </div>
                </el-col>              
              </el-row>               
            　<el-row style="text-align:left;">
              　<el-col :span="4" style="margin-left:50px;">       
                  <el-form-item label="種別" prop="income_type">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.income_type" size="mini" style="width:80%;"></el-input>
                  </el-form-item>
               </el-col> 
              　<el-col :span="4" style="margin-left:74px;">              
                  <el-form-item label="支払金額" prop="income_year">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.income_year" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>
              　<el-col :span="4" style="margin-left:74px;">              
                  <el-form-item label="給与所得控除後の金額" prop="income_deduction_after">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.income_deduction_after" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>
              　<el-col :span="4" style="margin-left:74px;">              
                  <el-form-item label="所得金額調整控除額" prop="income_adj">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.income_adj" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>                                                                                                
             </el-row>
            　<el-row style="text-align:left;">
              　<el-col :span="4" style="margin-left:50px;">              
                  <el-form-item label="基礎控除の額" prop="basic_deduction">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.basic_deduction" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>              
              　<el-col :span="4" style="margin-left:74px;">              
                  <el-form-item label="所得控除の額の合計額" prop="deduction_total">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.deduction_total" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>                      
              　<el-col :span="4" style="margin-left:74px;">               
                  <el-form-item label="源泉徴収税額" prop="preparation_tax_amount">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.preparation_tax_amount" size="mini" style="width:80%;"></el-input>
                    円
                  </el-form-item>
               </el-col>                                                                                     
             </el-row>                          
          　</el-collapse-item>

          　<el-collapse-item title="配偶者控除" name="3">
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                   
                  <el-form-item label="控除対象配偶者の有無等" prop="spousal_is_deductible">
                    <el-select style="width:180px; margin-right:80px;" v-model="ruleForm.spousal_is_deductible" size="mini" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in spousal" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
               </el-col> 
             </el-row>
             <div v-if="ruleForm.spousal_is_deductible !=''">                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="配偶者（特別）控除の額" prop="spousal_deduction">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.spousal_deduction" size="mini" style="width: 180px; margin-left:26px;"></el-input>
                    円
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="配偶者の合計所得" prop="spousal _total_income">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.spousal_total_income" size="mini" style="width: 180px; margin-left:55px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="配偶者氏名" prop="spousal_name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.spousal_name" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="配偶者氏名（フリガナ）" prop="spousal_name_flgn">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.spousal_name_frgn" size="mini" style="width: 180px; margin-right:103px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="配偶者個人番号" prop="spousal_num">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.spousal_num" size="mini" style="width: 180px; margin-right:22px;" readonly></el-input>
                  </el-form-item>
                </div>
                </el-col>
              　<el-col :span="12" >
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item prop="spousal_section">
                    <el-checkbox v-model="ruleForm.spousal_section">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="扶養控除" name="4">
            　<el-row style="margin-left:50px; text-align:left;">                  
              　<el-col :span="24">
                  <el-form-item label="控除対象扶養親族の数（配偶者を除く）">                                                          
                    特定
                    <el-input v-model="ruleForm.dependent_number_special" size="mini" style="width: 45px;">                      
                    </el-input>&nbsp;人&nbsp;
                    <el-input v-model="ruleForm.dependent_number_special_s" size="mini" style="width: 45px;">
                    </el-input>&nbsp;従人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    老人
                    <el-input v-model="ruleForm.old_together_number" size="mini" style="width: 45px;">                      
                    </el-input>&nbsp;内&nbsp;
                    <el-input v-model="ruleForm.dependent_number_old" size="mini" style="width: 45px;">
                    </el-input>&nbsp;人&nbsp;                    
                    <el-input v-model="ruleForm.dependent_number_old_s" size="mini" style="width: 45px;">
                    </el-input>&nbsp;&nbsp;従人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                                                 
                    その他
                    <el-input v-model="ruleForm.dependent_number_general" size="mini" style="width: 45px;">                      
                    </el-input>&nbsp;人&nbsp;
                    <el-input v-model="ruleForm.dependent_number_general_s" size="mini" style="width: 45px;">
                    </el-input>&nbsp;従人                                     
                  </el-form-item>                 
               </el-col>
             </el-row>
            　<el-row style="margin-left:50px; text-align:left;">                  
              　<el-col :span="24">
                  <el-form-item label="障害者の数（本人を除く）">
                    <span style="margin-left:85px;">特別</span>
                    <el-input v-model="ruleForm.disabled_together_number" size="mini" style="width: 45px;">                      
                    </el-input>&nbsp;内&nbsp;
                    <el-input v-model="ruleForm.disabled_number_special" size="mini" style="width: 45px;">
                    </el-input>&nbsp;人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                                                 
                    その他
                    <el-input v-model="ruleForm.disabled_number_general" size="mini" style="width: 45px;">                      
                    </el-input>&nbsp;人&nbsp;                         
                  </el-form-item>                 
               </el-col>               
             </el-row>                                      
            　<el-row style="margin-left:50px; text-align:left;">                  
              　<el-col :span="12">
                  <el-form-item label="16歳未満扶養親族の数">
                    <el-input v-model="ruleForm.dependent_number_young" size="mini" style="width: 45px; margin-left:142px;">                      
                    </el-input>&nbsp;人                             
                  </el-form-item>                 
               </el-col>                            
             </el-row>
            　<el-row style="margin-left:50px; text-align:left;">                  
              　<el-col :span="12">
                  <el-form-item label="非居住者である親族の数">
                    <el-input v-model="ruleForm.dependent_number_no_tog" size="mini" style="width: 45px;margin-left:130px;">
                    </el-input>&nbsp;人                                                                          
                  </el-form-item>                 
               </el-col>               
             </el-row>                
            　<el-row style="margin-left:50px; text-align:left;">                  
              　<el-col :span="12">
                  <el-form-item label="備考">
                　　<el-input type="textarea" :rows="4" prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini" style="width: 400px;"></el-input>                                                                         
                  </el-form-item>                 
               </el-col>
              　<el-col :span="12">
                  <el-form-item label="摘要">
                　　<el-input type="textarea" :rows="4" prefix-icon="el-icon-edit" v-model="ruleForm.description" size="mini" style="width: 400px;"></el-input>                                                                         
                  </el-form-item>                 
               </el-col>                              
             </el-row>                
          　</el-collapse-item>

          　<el-collapse-item title="控除対象扶養親族１" name="5">
             <div>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="d_name_a">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_a" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="d_name_flgn_a">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_flgn_a" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族個人番号" prop="d_num_a">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_num_a" size="mini" style="width: 180px; margin-right:22px;" readonly></el-input>
                  </el-form-item>
                </div>
                </el-col>
              　<el-col :span="12" >
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item prop="d_section_a">
                    <el-checkbox v-model="ruleForm.d_section_a">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="控除対象扶養親族２" name="6">
             <div>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="d_name_b">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_b" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="d_name_flgn_b">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_flgn_b" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族個人番号" prop="d_num_b">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_num_b" size="mini" style="width: 180px; margin-right:22px;" readonly></el-input>
                  </el-form-item>
                </div>
                </el-col>
              　<el-col :span="12" >
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item prop="d_section_b">
                    <el-checkbox v-model="ruleForm.d_section_b">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="控除対象扶養親族３" name="7">
             <div>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="d_name_c">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_c" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="d_name_flgn_c">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_flgn_c" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族個人番号" prop="d_num_c">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_num_c" size="mini" style="width: 180px; margin-right:22px;" readonly></el-input>
                  </el-form-item>
                </div>
                </el-col>
              　<el-col :span="12" >
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item prop="d_section_c">
                    <el-checkbox v-model="ruleForm.d_section_c">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="控除対象扶養親族４" name="8">
             <div>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="d_name_d">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_d" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="d_name_flgn_d">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_name_flgn_d" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
             </el-row>
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族個人番号" prop="d_num_d">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.d_num_d" size="mini" style="width: 180px; margin-right:22px;" readonly></el-input>
                  </el-form-item>
                </div>
                </el-col>
              　<el-col :span="12" >
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item prop="d_section_d">
                    <el-checkbox v-model="ruleForm.d_section_d">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="16歳未満の扶養親族１" name="9" v-if="ruleForm.dependent_number_young==='1'">
             <div>                         
            　<el-row>
              　<el-col :span="9">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="y_name_a">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_a" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="11">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="y_name_flgn_a">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_flgn_a" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
              　<el-col :span="2" >
                <div style="text-align:left;">                
                  <el-form-item prop="y_section_a">
                    <el-checkbox v-model="ruleForm.y_section_a">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="16歳未満の扶養親族２" name="10" v-if="ruleForm.dependent_number_young==='2'">
             <div>                         
            　<el-row>
              　<el-col :span="9">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="spousal_name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_b" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="11">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="spousal_name_flgn">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_flgn_b" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
              　<el-col :span="2" >
                <div style="text-align:left;">                
                  <el-form-item prop="y_section_b">
                    <el-checkbox v-model="ruleForm.y_section_b">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="16歳未満の扶養親族３" name="11" v-if="ruleForm.dependent_number_young==='3'">
             <div>                         
            　<el-row>
              　<el-col :span="9">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="y_name_c">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_c" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="11">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="spousal_name_flgn">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_flgn_c" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
              　<el-col :span="2" >
                <div style="text-align:left;">                
                  <el-form-item prop="y_section_c">
                    <el-checkbox v-model="ruleForm.y_section_c">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="16歳未満の扶養親族４" name="12" v-if="ruleForm.dependent_number_young==='4'">
             <div>                         
            　<el-row>
              　<el-col :span="9">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名" prop="y_name_d">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_d" size="mini" style="width: 180px; margin-left:5px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="11">
                <div style="margin-left:50px;">                
                  <el-form-item label="扶養親族氏名（フリガナ）" prop="y_name_flgn_d">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.y_name_flgn_d" size="mini" style="width: 180px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>                              
              　<el-col :span="2" >
                <div style="text-align:left;">                
                  <el-form-item prop="y_section_d">
                    <el-checkbox v-model="ruleForm.y_section_d">区分</el-checkbox>
                  </el-form-item>
                </div>
               </el-col>                                       
             </el-row>                           
             </div>  
          　</el-collapse-item>

          　<el-collapse-item title="保険料控除" name="13">                         
            　<el-row>
              　<el-col :span="8">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="社会保険料等の金額" prop="social_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.social_insurance" size="mini" style="width: 110px; margin-left:30px;"></el-input>
                    円
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:40px;text-align:left;">                
                  <el-form-item label="生命保険料の控除額" prop="life_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.life_insurance" size="mini" style="width: 110px;  margin-left:30px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:30px;text-align:left;">                
                  <el-form-item label="地震保険料の控除額" prop="earthquake_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.earthquake_insurance" size="mini" style="width: 110px; margin-left:30px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                                              
             </el-row>
            　<el-row>
              　<el-col :span="8">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="新生命保険料の金額" prop="life_insurance_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.life_insurance_a" size="mini" style="width: 110px;  margin-left:30px;"></el-input>
                    円
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:40px;text-align:left;">                
                  <el-form-item label="旧生命保険料の金額" prop="life_insurance_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.life_insurance_b" size="mini" style="width: 110px; margin-left:30px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
            　</el-row>
              <el-row>
              　<el-col :span="8">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="介護医療保険料の金額" prop="care_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.care_insurance" size="mini" style="width: 110px;  margin-left:15px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:40px;text-align:left;">                
                  <el-form-item label="新個人年金保険料の金額" prop="annuity_insurance_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.annuity_insurance_a" size="mini" style="width: 110px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:30px;text-align:left;">                
                  <el-form-item label="旧個人年金保険料の金額" prop="annuity_insurance_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.annuity_insurance_b" size="mini" style="width: 110px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="国民年金保険料等の金額" prop="national_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.national_insurance" size="mini" style="width: 110px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="8">
                <div style="margin-left:40px;text-align:left;">                
                  <el-form-item label="旧長期損害保険料の金額" prop="damage_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.damage_insurance" size="mini" style="width: 110px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                                                                                             
             </el-row>                                                        
          　</el-collapse-item>

          　<el-collapse-item title="住宅借入金等特別控除" name="14">
              <el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等特別控除の額" prop="house_deduction">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_deduction" size="mini" style="width: 180px;　margin-left:70px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                                              
             </el-row>                         
            　<el-row>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等特別控除適用数" prop="house_deduction_num">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_deduction_num" size="mini" style="width: 180px; margin-left:55px;"></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="居住開始年月日（１回目）" prop="live_begin_a">
                    <el-date-picker v-model="ruleForm.live_begin_a" size="mini" value-format="yyyy-MM-dd" style="width: 180px; margin-left:40px; " type="date"></el-date-picker>
                  </el-form-item>
                </div>  
               </el-col>              
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等特別控除可能額" prop="house_deduction_able">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_deduction_able" size="mini" style="width: 180px; margin-left:55px;" readonly></el-input>
                  円
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="居住開始年月日（２回目）" prop="live_begin_b">
                    <el-date-picker v-model="ruleForm.live_begin_b" size="mini" value-format="yyyy-MM-dd" style="width: 180px; margin-left:40px; " type="date"></el-date-picker>
                  </el-form-item>
                </div>  
               </el-col> 
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等特別控除区分（１回目）" prop="house_section_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_section_a" size="mini" style="width: 180px;"></el-input>
                  </el-form-item>
                </div>  
               </el-col>                
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等年末残高（１回目）" prop="house_last_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_last_a" size="mini" style="width: 180px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等特別控除区分（２回目）" prop="house_section_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_section_b" size="mini" style="width: 180px;"></el-input>
                  </el-form-item>
                </div>  
               </el-col>
              　<el-col :span="12">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住宅借入金等年末残高（２回目）" prop="house_last_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.house_last_b" size="mini" style="width: 180px;"></el-input>
                    円
                  </el-form-item>
                </div>  
               </el-col>                                                                    
             </el-row>                          
          　</el-collapse-item>

          　<el-collapse-item title="支払者" name="15">
              <el-row>
              　<el-col :span="24">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="個人番号又は法人番号" prop="c_num">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.c_num" size="mini" style="width: 280px;　margin-left:70px;" readonly></el-input>
                  </el-form-item>
                </div>  
               </el-col>                                              
             </el-row>                         
            　<el-row>
              　<el-col :span="24">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="住所（居所）又は所在地" prop="c_addess">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.c_addess" size="mini" style="width: 700px; margin-left:55px;" readonly></el-input>
                  </el-form-item>
                </div>
               </el-col>
              　<el-col :span="24">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="氏名又は名称" prop="c_name">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.c_name" size="mini" style="width: 280px; margin-left:125px;" readonly></el-input>
                  </el-form-item>
                </div>  
               </el-col>              
              　<el-col :span="24">
                <div style="margin-left:50px;text-align:left;">                
                  <el-form-item label="電話番号" prop="c_tel">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.c_tel" size="mini" style="width: 280px; margin-left:155px;" readonly></el-input>
                  </el-form-item>
                </div>  
               </el-col>                                                                    
             </el-row>                          
          　</el-collapse-item>                               
        　</el-collapse>                                        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSalary('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>
<!-- 給与所得者の保険料控除申告書 -->
    <el-dialog title="" :visible.sync="dialogIns" width="94%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
　　　　　 <div style="margin-bottom:40px;">
            <h3>{{ruleForm.year}}&nbsp;&nbsp;給与所得者の保険料控除申告書</h3>  
          </div>
        　<el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="" name="1">                         
            　<el-row style="margin-left:50px; text-align:left;">
              　<el-col :span="6">              
                  <el-form-item label="新生命保険料等の金額の合計額" prop="life_insurance_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.life_insurance_a" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>

              　<el-col :span="6">             
                  <el-form-item label="旧生命保険料等の金額の合計額" prop="life_insurance_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.life_insurance_b" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>

              　<el-col :span="6">              
                  <el-form-item label="介護医療保険料の金額の合計額" prop="care_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.care_insurance" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item> 
               </el-col>

              　<el-col :span="6">             
                  <el-form-item label="新個人年金保険料等の金額の合計額" prop="annuity_insurance_a">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.annuity_insurance_a" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item> 
               </el-col>

              　<el-col :span="6">             
                  <el-form-item label="旧個人年金保険料等の金額の合計額" prop="annuity_insurance_b">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.annuity_insurance_b" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>
               
              　<el-col :span="6">            
                  <el-form-item label="地震保険料の金額の合計額" prop="earthquake_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.earthquake_insurance" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>
              　<el-col :span="6">              
                  <el-form-item label="旧長期損害保険料の金額の合計額" prop="damage_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.damage_insurance" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col> 
              　<el-col :span="6">              
                  <el-form-item label="社会保険料控除合計額" prop="social_insurance">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.social_insurance" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>
              　<el-col :span="6">              
                  <el-form-item label="小規模企業共済等掛金控除の合計額" prop="c_deduction">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.c_deduction" size="mini" style="width: 210px;"></el-input>
                    円
                  </el-form-item>
               </el-col>                                                                                                                                           
              </el-row>                                                       
          　</el-collapse-item>                            
        　</el-collapse>                                                
      </el-form>

      <div style="text-align:right; margin-top:20px;margin-bottom:20px;">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="insFormAdd">給与所得者の保険料控除申告書詳細作成</el-button>
      </div>              
      <el-table :data="insData" highlight-current-row border style="width: 100%;" :empty-text="$t('general.empty_data')">
        <el-table-column prop="ins_type" label="保険料の種類" align="center" width="110px">
          <template slot-scope="scope">
            <span>{{ scope.row.ins_type }}</span>
          </template>
      　</el-table-column>

      　<el-table-column prop="ins_c_name" label="保険会社等・保険料支払先の名称" align="center" width="180px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_c_name }}</span>
          </template>
        </el-table-column>

      　<el-table-column prop="ins_type_detail" label="保険等の種類" align="center" width="110px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_type_detail }}</span>
          </template>
        </el-table-column>

      　<el-table-column prop="ins_date" label="保険期間又は年金支払期間" align="center" width="110px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_date }}</span>
          </template>
        </el-table-column>

      　<el-table-column prop="ins_apply_name" label="保険等契約者・負担者氏名" align="center" width="120px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_apply_name }}</span>
          </template>
        </el-table-column> 

      　<el-table-column prop="ins_recevie_name" label="受取者氏名" align="center" width="100px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_recevie_name }}</span>
          </template>
        </el-table-column>

      　<el-table-column prop="ins_relation" label="あなたと続柄" align="center" width="110px">
        　<template slot-scope="scope">
            <span>{{ scope.row.ins_relation }}</span>
          </template>
        </el-table-column>                                                                   

      　<el-table-column prop="district" label="区分" align="center" width="110px">
        　<template slot-scope="scope">
            <span>{{ scope.row.district }}</span>
          </template>
        </el-table-column>

      　<el-table-column prop="district" label="支払った金額" align="center" width="110px">
        　<template slot-scope="scope">
            <span>{{ scope.row.district }}</span>
          </template>
        </el-table-column> 

      　<el-table-column prop="confirm" label="給与の支払者の確認" align="center"  width="100px">
        　<template slot-scope="scope">
            <span>{{ scope.row.confirm }}</span>
          </template>
        </el-table-column>

      　<el-table-column :label="$t('general.operation')" align="center" fixed="right" width="220px">
        　<template slot-scope="scope">
          　<el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{ $t("general.edit") }}</el-button>
          　<el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeleteAll(scope.$index, scope.row)">
            {{ $t("general.delete") }}</el-button>
        　</template>
      　</el-table-column>                 
    　</el-table>      
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSalary('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>
<!-- 給与所得者の保険料控除申告書詳細作成 -->
    <el-dialog title="給与所得者の保険料控除申告書詳細作成" :visible.sync="dialogInsDetail" width="72%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <el-row style=" text-align:left; font-weight:bold;">
            <el-col :span="8">
              <el-form-item prop="ins_type">保険料の種類
                <el-select style="width:180px;margin-left:10px;" v-model="ruleForm.ins_type" size="mini" :placeholder="$t('general.select')">
                  <el-option v-for="item in ins_type" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        　<el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="生命保険料控除" name="1" v-if="ruleForm.ins_type === '一般の生命保険料' || ruleForm.ins_type === '介護医療保険料' || ruleForm.ins_type === '個人年金保険料'">                         
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">              
                  <el-form-item label="保険会社等の名称" prop="ins_c_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">             
                  <el-form-item label="保険等の種類" prop="ins_type_detail">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">              
                  <el-form-item label="保険期間又は年金支払期間" prop="ins_date">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                  </el-form-item> 
               </el-col>

              　<el-col :span="8">             
                  <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                  </el-form-item> 
               </el-col>

              　<el-col :span="16">             
                  <el-form-item label="保険金等の受取人">
                    <br>
                    氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                    <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">            
                  <el-form-item label="新・旧保険料の区分" prop="district">
                    <br>
                    <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                      <el-radio label="地震">新</el-radio>
                      <el-radio label="旧長期" style="margin-left:150px;">旧</el-radio>
                    </el-radio-group>                    
                  </el-form-item>
               </el-col>
              　<el-col :span="8">              
                  <el-form-item label="あなたが本年中に支払った保険料等の金額" prop="ins_payment">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                    円
                  </el-form-item>
               </el-col> 
              　<el-col :span="8">              
                  <el-form-item label="給与の支払者の確認" prop="confirm">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>                                                                                                                                          
              　<el-col :span="24" v-if="ruleForm.ins_type ==='個人年金保険料'">              
                  <el-form-item label="年金支払開始日" prop="pay_date">
                    <br>
                    <el-select style="width:75px;" v-model="ruleForm.era" size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in era" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>                    
                    <el-input v-model="ruleForm.payYear" size="mini" style="width: 45px;"></el-input>
                    年
                    <el-input v-model="ruleForm.payMonth" size="mini" style="width: 45px;"></el-input>
                    月
                    <el-input v-model="ruleForm.payDay" size="mini" style="width: 45px;"></el-input>
                    日
                  </el-form-item>
               </el-col>                                                                                                                                          
              </el-row>                                                      
          　</el-collapse-item>
          　<el-collapse-item title="地震保険料控除" name="2" v-if="ruleForm.ins_type === '地震保険料'">                         
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">              
                  <el-form-item label="保険会社等の名称" prop="ins_c_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">             
                  <el-form-item label="保険等の種類（目的）" prop="ins_type_detail">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">              
                  <el-form-item label="保険期間" prop="ins_date">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                  </el-form-item> 
               </el-col>

              　<el-col :span="8">             
                  <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                  </el-form-item> 
               </el-col>

              　<el-col :span="16">             
                  <el-form-item label="保険等の対象となった家屋等に居住又は家財を利用している者等">
                    <br>
                    氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                    <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">            
                  <el-form-item label="地震保険料又は旧長期損害保険料区分" prop="district">
                    <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                      <el-radio label="地震">地震</el-radio>
                      <el-radio label="旧長期" style="margin-left:110px;">旧長期</el-radio>
                    </el-radio-group>                    
                  </el-form-item>
               </el-col>
              　<el-col :span="16">              
                  <el-form-item label="あなたが本年中に支払った保険等のうち、左欄の区分に係る金額" prop="ins_payment">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                    円
                  </el-form-item>
               </el-col> 
              　<el-col :span="8">              
                  <el-form-item label="給与の支払者の確認" prop="confirm">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>                                                                                                                                                                                                                                                                                  
              </el-row>                                                      
          　</el-collapse-item>

          　<el-collapse-item title="社会保険料控除" name="3" v-if="ruleForm.ins_type === '社会保険料'">                         
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">             
                  <el-form-item label="社会保険の種類" prop="ins_type_detail">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">              
                  <el-form-item label="保険料支払先の名称" prop="ins_c_name">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                  </el-form-item>
               </el-col>

              　<el-col :span="8">              
                  <el-form-item label="あなたが本年中に支払った保険料の金額" prop="ins_payment">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                    円
                  </el-form-item>
               </el-col>

              　<el-col :span="16">             
                  <el-form-item label="保険料を負担することになっている人">
                    <br>
                    氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                    <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                  </el-form-item>
               </el-col>                                                                                                                                                                                                                                                                      
              </el-row>                                                      
          　</el-collapse-item>

          　<el-collapse-item title="小規模企業共済等掛金控除" name="4" v-if="ruleForm.ins_type === '小規模企業共済等掛金'">                         
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="12">             
                  <el-form-item label="種類" prop="ins_type_detail">
                    <el-select style="width:350px;" v-model="ruleForm.ins_type_detail" size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in ins_type_detail" :key="item.id" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>

              　<el-col :span="12">              
                  <el-form-item label="あなたが本年中に支払った掛金の金額" prop="ins_payment">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 170px;"></el-input>
                    円
                  </el-form-item>
               </el-col>
                                                                                                                                                                                                                                                                     
              </el-row>                                                      
          　</el-collapse-item>                                                                            
        　</el-collapse>                                        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSalary('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogAdd: false,
      dialogIns: false,
      dialogInsDetail: false,
      activeNames: ['1', '2', '3', '4', '13', '14', '15'],
      ruleForm: {
        year: "令和03年分",
        employee_id: "",
        mynum:"",
        name: "",
        name_frgn: "",
        birthday: "",
        title: "",
        address: "",
        post_code: "",
        address1: "",
        address2: "",
        address3: "",
        income_type: "",
        income_year: "",
        income_deduction_after: "",
        deduction_total: "",
        preparation_tax_amount: "",
        recevier_type_disabled: "",
        recevier_type_single: "",
        recevier_is_work_student: "",
        recevier_is_Foreign: "",
        recevier_is_death: "",
        recevier_is_saigai: "",
        recevier_is_b: "",
        mid_career: "",
        career_date: "",
        spousal_is_deductible: "",
        spousal_total_income: "",
        basic_deduction: "",
        income_adj: "",
        spousal_name: "",
        spousal_name_frgn: "",
        spousal_num: "",
        spousal_section: "",
        dependent_number_special: "",
        dependent_number_special_s: "",
        old_together_number: "",
        dependent_number_old: "",
        dependent_number_old_s: "",
        dependent_number_general: "",
        dependent_number_general_s: "",
        disabled_together_number: "",
        disabled_number_general: "",
        dependent_number_young: "",
        dependent_number_no_tog: "",
        remark: "",
        description: "",
        social_insurance: "",
        life_insurance: "",
        earthquake_insurance: "",
        life_insurance_a: "",
        life_insurance_b: "",
        care_insurance: "",
        annuity_insurance_a: "",
        annuity_insurance_b: "",
        national_insurance: "",
        damage_insurance: "",
        house_deduction: "",
        house_deduction_num: "",
        live_begin_a: "",
        house_deduction_able: "",
        live_begin_b: "",
        house_section_a: "",
        house_last_a: "",
        house_section_b: "",
        house_last_b: "",
        d_name_a: "",
        d_name_flgn_a: "",
        d_num_a: "",
        d_section_a: "",
        d_name_b: "",
        d_name_flgn_b: "",
        d_num_b: "",
        d_section_b: "",
        d_name_c: "",
        d_name_flgn_c: "",
        d_num_c: "",
        d_section_c: "",
        d_name_d: "",
        d_name_flgn_d: "",
        d_num_d: "",
        d_section_d: "", 
        y_name_a: "",
        y_name_flgn_a: "",
        y_num_a: "",
        y_section_a: "",
        y_name_b: "",
        y_name_flgn_b: "",
        y_num_b: "",
        y_section_b: "",
        y_name_c: "",
        y_name_flgn_c: "",
        y_num_c: "",
        y_section_c: "",
        y_name_d: "",
        y_name_flgn_d: "",
        y_num_d: "",
        y_section_d: "",                       
        c_num: "",                       
        c_addess: "",                       
        c_name: "",                       
        c_tel: "",                       
        era: "令和",                       
        ins_type: "一般の生命保険料",                       
      },

      year: [
        {
          label: "令和02年分",
          value: "令和02年分",
        },
        {
          label: "令和03年分",
          value: "令和03年分",
        }
      ],
      disabled: [
        {
          label: "特別",
          value: "特別",
        },
        {
          label: "その他",
          value: "その他",
        }
      ],
      single: [
        {
          label: "寡婦",
          value: "寡婦",
        },
        {
          label: "ひとり親",
          value: "ひとり親",
        }
      ],
      mid_career: [
        {
          label: "就職",
          value: "就職",
        },
        {
          label: "退職",
          value: "退職",
        }
      ],      
      spousal: [
        {
          label: "有",
          value: "有",
        },
        {
          label: "従有",
          value: "従有",
        },
        {
          label: "有（老人）",
          value: "有（老人）",
        },      
      ],      
      ins_type: [
        {
          label: "一般の生命保険料",
          value: "一般の生命保険料",
        },
        {
          label: "介護医療保険料",
          value: "介護医療保険料",
        },
        {
          label: "個人年金保険料",
          value: "個人年金保険料",
        },      
        {
          label: "地震保険料",
          value: "地震保険料",
        },      
        {
          label: "社会保険料",
          value: "社会保険料",
        },      
        {
          label: "小規模企業共済等掛金",
          value: "小規模企業共済等掛金",
        },      
      ],      
      district: [
        {
          label: "新",
          value: "新",
        },
        {
          label: "旧",
          value: "旧",
        }
      ],
      era: [
        {
          label: "明治",
          value: "M",
        },
        {
          label: "大正",
          value: "T",
        },
        {
          label: "昭和",
          value: "S",
        },
        {
          label: "平成",
          value: "H",
        },
        {
          label: "令和",
          value: "R",
        },                        
      ],      
      ins_type_detail: [
        {
          label: "独立行政法人中小企業基盤整備機構の共済契約の掛金",
          value: "独立行政法人中小企業基盤整備機構の共済契約の掛金",
        },
        {
          label: "確定拠出年金法に規定する企業型年金加入者掛金",
          value: "確定拠出年金法に規定する企業型年金加入者掛金",
        },
        {
          label: "確定拠出年金法に規定する個人型年金加入者掛金",
          value: "確定拠出年金法に規定する個人型年金加入者掛金",
        },
        {
          label: "心身障害者扶養共済制度に関する契約の掛金",
          value: "心身障害者扶養共済制度に関する契約の掛金",
        }                    
      ],      

    };
  },
  methods: {
    //新規ボタンを押下する
    taxFormAdd() {
      this.dialogAdd = true;
    },

    insFormAdd(){
      this.dialogInsDetail = true;
    },   
  },
  created() {
 
  },  
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/EndYearAdj/TaxForm.vue